import http from "../BaseServiceHttp";

class PackageService {
  getPackageDefinitions() {
    return http.get(`/packages`);
  }
}

export default new PackageService();
